import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import getProductDetails from '#client/pages/ProductLanding/helper';

import { PRODUCT_FLAG_MAPPING } from '../constants/productFlags';

export const useProductDetails = (productId) => {
  const { entitlements } = useBusinessEntity();
  const flagConstant = PRODUCT_FLAG_MAPPING[productId];
  const flagValue = useExperimentFlag(flagConstant || '', false, false, !flagConstant);
  const productDetails = getProductDetails(productId);

  return typeof productDetails === 'function' ? productDetails(flagValue, entitlements) : productDetails;
};
